import { UntypedFormGroup } from "@angular/forms";
import { cloneDeep } from "lodash";

export const defaultIdValue ='other';
export const defaultId =  {id:defaultIdValue, name:''};
export function isDefaultId(element: any): boolean {
  if(!element) return false;
  // console.log(element)
  //si hay elemento y, es un string con el key ó es un obj con el id del string del key
  return (element==defaultIdValue || element.id==defaultIdValue);
}

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
export function uidI() {
  return 'ixxxxxxx-yxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const ifMoment2Date = (property: any)=>  (property && typeof property.toDate === 'function') ?  property.toDate() : property;
export { ifMoment2Date }

const toDate = (property:any) => property && isFunction(property.toDate) ?  property.toDate() : property;
export { toDate }

const isFunction = (fn: any)  => typeof fn === "function";
export { isFunction }

export function enumToArray(enumme: { [x: string]: any; }) {
  return Object.keys(enumme)
      .map(key => enumme[key]);
}


/**
 * Returns the enum as an array
 * where [0] represents the key and [1] the value
 */
export function enumToArray_Entries(enumme: { [x: string]: any; }){
  let e = Object.entries(enumme);
  return e.slice(e.length/2);
}


export const compareById = (o1: any, o2:any) => o1?.id === o2?.id;

export const __getInvalids = (form:UntypedFormGroup) =>{
 const isInvalid = form.invalid;
 let controls = Object.entries(form.controls);
 let invalids = [];
 controls.forEach(c => {
   if(c[1].invalid) invalids.push(c);
 });
//  console.log({isInvalid, invalids});
}

export const roundX = (num, decimals=2)=>{
  const mult = 10 ** decimals;
  return Math.round((num + Number.EPSILON) * mult) / mult;
}


/**
* Used to fill a object that require properties that it doesn't have yet
*/
export const fillMissingPropertiesOfObject = (oToFill, oWithProperties):any=>{
  let newObject = cloneDeep(oToFill) ?? {};

  Object.keys(oWithProperties).forEach(key=>{
    if(!oToFill[key]) newObject[key] = oWithProperties[key];
  })
  return newObject;
}
export const removeNullPropertiesOfObject = (oToRemove)=>{
  Object.keys(oToRemove).forEach(key=>{
    if(oToRemove[key] === null) delete oToRemove[key];
  })
}


/**
 * Remove a list of type T from a list of type T
 * Example: removeListFromList(['a','b','c','d'], ['a','c']) => ['b','d']
 */
export const removeFromList = <T>(list: T[], ...listToRemove: T[]): T[] => {
  return list?.filter((item) => !listToRemove?.includes(item)) ?? [];
}
